import {Component,Input,OnChanges,SimpleChanges} from "@angular/core";
import {ControlContainer,NgForm} from "@angular/forms";
import {AbattementDetail} from "@components/admin/frais/indemnites/indemnites-abattements/detail/indemnites-abattement-detail.component";
import {TranslateService} from "@ngx-translate/core";

/**
 * Onglet généralités du détail abattement
 */
@Component({
    host: {'data-test-id': 'indemnites-abattement-generalites'},
    selector: 'indemnites-abattement-generalites',
    templateUrl: './indemnites-abattement-generalites.component.html',
    viewProviders: [{provide: ControlContainer,useExisting: NgForm}]
})
export class IndemnitesAbattementGeneralitesComponent implements OnChanges {
    /** Abattement */
    @Input() abattement: AbattementDetail;

    /** Liste des horaires */
    @Input() listeHoraires: Array<{idHoraire?: number,libelle: string}> = [];

    /** Liste des types entité */
    @Input() listeTypesEntite: Array<{idTypeEntite?: number,libelle: string}> = [];

    /** Liste des horaires avec Tous */
    listeHorairesAvecTous: Array<{idHoraire?: number,libelle: string}> = [];

    /** Liste des types entité avec Tous */
    listeTypesEntiteAvecTous: Array<{idTypeEntite?: number,libelle: string}> = [];

    /**
     * Constructeur
     */
    constructor(private translateService: TranslateService) {
    }

    /**
     * Mise à jour des listes de sélection
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.listeHoraires || changes.listeTypesEntite) {
            this.mettreAJourListesAvecTous();
        }
    }

    /**
     * Construction des listes avec l'option Tous en premier
     */
    private mettreAJourListesAvecTous(): void {
        const libelleTous = this.translateService.instant('admin.frais.indemnites.abattements.detail.generalites.tous');

        this.listeHorairesAvecTous = [{idHoraire: 0,libelle: libelleTous},...(this.listeHoraires ?? []).filter(option => option?.idHoraire !== 0)];
        this.listeTypesEntiteAvecTous = [{idTypeEntite: 0,libelle: libelleTous},...(this.listeTypesEntite ?? []).filter(option => option?.idTypeEntite !== 0)];
    }
}
